import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@els/els-react--modal';
import { Icon } from '@els/els-react--icon';
import { ButtonWithIcon } from '@els/els-react--button';
import { LEGACY_DIALOG_SIZE } from '@Containers/Dialogs/DialogsConstants';

export default function AlertDeleteConfirmationModal({ onCancel, onConfirm }) {
  return (
    <Modal id="alerts-delete-confirmation-dialog" type="secondary" width={LEGACY_DIALOG_SIZE} onClose={onCancel}>
      <div>
        <header className="o-els-flex-layout o-els-flex-layout--left o-els-flex-layout--middle">
          <Icon sprite="AlertSolidSquare" size="m" color="secondary" isVisible isDecorative />
          <h4 id="alerts-confirm-dialog-title" className="u-els-margin-left">
            Delete
          </h4>
        </header>
        <section className="u-els-margin-top-1o2 u-els-margin-bottom u-els-margin-left-3x">
          Are you sure you want to delete this alert?
        </section>
        <footer className="o-els-flex-layout o-els-flex-layout--right o-els-flex-layout--middle">
          <ButtonWithIcon
            data-e2e="alert-delete-cancel-btn"
            type="secondary"
            sprite="Close"
            size="small"
            iconRight
            name="cancel"
            onClick={onCancel}>
            Cancel
          </ButtonWithIcon>
          <ButtonWithIcon
            data-e2e="alert-delete-confirm-btn"
            type="primary"
            sprite="ChevronRight"
            size="small"
            iconRight
            className="u-els-margin-left"
            name="confirm"
            onClick={onConfirm}>
            Yes
          </ButtonWithIcon>
        </footer>
      </div>
    </Modal>
  );
}

AlertDeleteConfirmationModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
